<script setup>
import {useUserStore} from "../../store/users.js";
import {onMounted, reactive, ref} from "vue";
import EmptyState from "../../components/global/EmptyState.vue";
import SectionHeader from "../../components/section/SectionHeader.vue";
import Pagination from "../../components/section/Pagination.vue";
import UserRowItem from "../../components/users/UserRowItem.vue";
import {useModalStore} from "../../store/modal";

const modalStore = useModalStore();
const store = useUserStore();
const userParams = reactive({
    sort_direction: 'desc',
    role: null,
})
const scrollSection = ref()
const userRoleOptions = store.roles
const userSortOptions = reactive([
    { label: 'Newest first', value: 'desc' },
    { label: 'Oldest first', value: 'asc' },
])
const getUsers = async (page = 1) => {
    await store.getAllUsers({
        ...userParams,
        page: page,
        paginate: 1
    })

    if(store.users && store?.users?.length) {
        scrollSection.value = 0
    }
}

const clearOtherFilters = async () => {
    userParams.role = null
    userParams.sort_direction = 'desc'
    await getUsers()
}

onMounted(async () => {
    await getUsers()
})
</script>

<template>
     <main v-if="!store.users">
        <empty-state icon="speechbubble-double" heading="Loading users." content="Give it sec, it's coming in a mo." />
    </main>

     <main v-else>
        <section>
            <section-header :heading="`Users.`">
                <div class="search-bar">
                    <brand-form-input label="Search by name, email or cell number" variant="search" />
                    <button class="mobile-filter-button" @click.prevent="modalStore.open('UserFilters', {}, null, 'center-bottom')">
                        <ah-icon name="filter-default" />
                    </button>
                </div>

                <brand-button as="button" variant="primary" @click.prevent="modalStore.open('AddUser', null, null, 'bottom-right')">Add<ah-icon name="plus-default" /></brand-button>
            </section-header>
            <div class="section-table" ref="scrollSection" v-if="store?.users?.data?.length">
                <user-row-item v-for="u in store?.users?.data" :user="u" />
            </div>
            <div class="section-table-empty" v-if="!store?.users?.data?.length">
                <h1>No Users match</h1>
            </div>
            <div class="section-footer" v-if="store?.users?.data?.length">
                <pagination :pagination="store?.users" @change-page="getUsers" />
            </div>
        </section>
        <aside class="section-sidebar">
            <div class="sidebar-header">
                <h2>Filters</h2>
                <p @click.prevent="clearOtherFilters">Clear</p>
            </div>
            <div class="sidebar-select">
                <brand-form-select variant="sidebar" label="Role." :options="userRoleOptions" v-model="userParams.role" />
            </div>
            <div class="sidebar-select">
                <brand-form-select variant="sidebar" label="Sorting." :options="userSortOptions" v-model="userParams.sort_direction" />
            </div>


            <div class="sidebar-footer">
                <brand-button as="button" variant="primary" @click.prevent="getUsers(1)">Apply</brand-button>
            </div>
        </aside>
    </main>
</template>

<style lang="scss" scoped>
.section-header {
    .section-header-actions {
        .search-bar {
            min-width: min(36.5rem, 100%);
        }
        .brand-button {
            display: flex;
            align-items: center;
            gap: 1rem;

            .icon {
                fill: var(--color-white);
            }

            @include mobile() {
                display: none;
            }
        }
    }
}
.section-sidebar {
    .sidebar-footer {
        .brand-button {
            width: 100%;
        }
    }
}
</style>
